import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchUserTasks = createAsyncThunk(
    "tasks/fetchUserTasks",
    async (params, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                `/api/task/list`,
                { params }
            );
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
